import { InjectionToken } from '@angular/core';
import { createMocks } from '@backbase/foundation-ang/data-http';
export const ARRANGEMENTS_DATA_HTTP_ANG_CONFIG = new InjectionToken(
  'product-summary-data-http-ang Data Service :: HTTP Config',
);
const examples = [
  {
    urlPattern: "/client-api/v2/account/statements",
    method: "GET",
    responses: [
      {
        status: 200,
        body: [{
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-02-15",
          "category": "Credit Card",
          "description": "Credit Card statement - February 2016",
          "documents": [
            {
              "url": "http://server.com/documentsdepo/uid_1",
              "contentType": "application/pdf"
            },
            {
              "url": "http://server.com/documentsdepo/uid_9_2",
              "contentType": "text/csv"
            }
          ]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-03-15",
          "category": "Credit Card",
          "description": "Credit Card statement - March 2016",
          "documents": []
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-04-15",
          "category": "Credit Card",
          "description": "Credit Card statement - April 2016",
          "documents": [{
            "uid": "uid_3",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-05-15",
          "category": "Credit Card",
          "description": "Credit Card statement - May 2016",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_4",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-06-15",
          "category": "Credit Card",
          "description": "Credit Card statement - June 2016",
          "documents": [{
            "uid": "uid_5",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-07-15",
          "category": "Credit Card",
          "description": "Credit Card statement - July 2016",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_6",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-08-15",
          "category": "Credit Card",
          "description": "Credit Card statement - August 2016",
          "documents": [{
            "uid": "uid_7",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-09-15",
          "category": "Credit Card",
          "description": "Credit Card statement - September 2016",
          "documents": [{
            "uid": "uid_8",
            "url": "",
            "contentType": ""
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-01-31",
          "category": "Account",
          "description": "Account statement - January 2017",
          "documents": [{
            "uid": "uid_9_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_9_2",
            "contentType": "text/csv"
          }, {
            "uid": "uid_9_3",
            "url": "http://server.com/documentsdepo/uid_9_3",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-02-28",
          "category": "Account",
          "description": "Account statement - February 2017",
          "documents": [{
            "uid": "uid_10_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_10_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-03-31",
          "category": "Account",
          "description": "Account statement - March 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_11_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_11_2",
            "url": "http://server.com/documentsdepo/uid_11_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-04-30",
          "category": "Account",
          "description": "Account statement - April 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_12_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_12_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-05-31",
          "category": "Account",
          "description": "Account statement - May 2017",
          "documents": [{
            "uid": "uid_13_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_13_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-06-30",
          "category": "Account",
          "description": "Account statement - June 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_14_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_14_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-07-31",
          "category": "Account",
          "description": "Account statement - July 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_15_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_15_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-08-31",
          "category": "Account",
          "description": "Account statement - August 2017",
          "documents": [{
            "uid": "uid_16_1",
            "url": "http://server.com/documentsdepo/uid_16_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_16_2",
            "url": "http://server.com/documentsdepo/uid_16_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-09-30",
          "description": "Statement - September 2017",
          "documents": [{
            "uid": "uid_17_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-10-31",
          "category": "Account",
          "description": "Account statement - October 2017",
          "documents": [{
            "uid": "uid_18_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_18_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-11-30",
          "category": "Account",
          "description": "Account statement - November 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_19_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_19_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-12-31",
          "category": "Account",
          "description": "Account statement - December 2017",
          "documents": [{
            "uid": "uid_20_1",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-05-19",
          "category": "Mortgage",
          "description": "Mortgage statement - May 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_21",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-06-19",
          "category": "Mortgage",
          "description": "Mortgage statement - June 2017",
          "documents": [{
            "uid": "uid_22",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-07-19",
          "category": "Mortgage",
          "description": "Mortgage statement - July 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_23",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-08-19",
          "category": "Mortgage",
          "description": "Mortgage statement - August 2017",
          "documents": [{
            "uid": "uid_24",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-09-19",
          "category": "Mortgage",
          "description": "Mortgage statement - September 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_25",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-10-19",
          "category": "Mortgage",
          "description": "Mortgage statement - October 2017",
          "documents": [{
            "uid": "uid_26",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-11-19",
          "category": "Mortgage",
          "description": "Mortgage statement - November 2017",
          "documents": [{
            "uid": "uid_27",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-12-19",
          "category": "Mortgage",
          "description": "Mortgage statement - December 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_28",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2018-01-19",
          "category": "Mortgage",
          "description": "Mortgage statement - January 2018",
          "documents": [{
            "uid": "uid_29",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "1cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-12-31",
          "category": "Tax Forms",
          "description": "Tax form - 2017",
          "documents": [{
            "uid": "uid_30",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-02-09",
          "category": "Credit Card",
          "description": "Credit Card statement - February 2016",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_31",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-03-09",
          "category": "Credit Card",
          "description": "Credit Card statement - March 2016",
          "documents": [{
            "uid": "uid_32",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-04-09",
          "category": "Credit Card",
          "description": "Credit Card statement - April 2016",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_33",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-05-09",
          "category": "Credit Card",
          "description": "Credit Card statement - May 2016",
          "documents": [{
            "uid": "uid_34",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-06-09",
          "category": "Credit Card",
          "description": "Credit Card statement - June 2016",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_35",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-07-09",
          "category": "Credit Card",
          "description": "Credit Card statement - July 2016",
          "documents": [{
            "uid": "uid_36",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-08-09",
          "category": "Credit Card",
          "description": "Credit Card statement - August 2016",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_37",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2016-09-09",
          "category": "Credit Card",
          "description": "Credit Card statement - September 2016",
          "documents": [{
            "uid": "uid_38",
            "url": "",
            "contentType": ""
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-01-31",
          "category": "Account",
          "description": "Account statement - January 2017",
          "documents": [{
            "uid": "",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_39_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-02-28",
          "category": "Account",
          "description": "Account statement - February 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_40_1",
            "contentType": "application/pdf"
          }, {
            "url": "",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-03-31",
          "category": "Account",
          "description": "Account statement - March 2017",
          "documents": [{
            "uid": "uid_41_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_41_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-04-30",
          "category": "Account",
          "description": "Account statement - April 2017",
          "documents": [{
            "uid": "uid_42_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_42_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-05-31",
          "category": "Account",
          "description": "Account statement - May 2017",
          "documents": [{
            "uid": "uid_43_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_43_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-06-30",
          "category": "Account",
          "description": "Account statement - June 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_44_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_44_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-07-31",
          "category": "Account",
          "description": "Account statement - July 2017",
          "documents": [{
            "uid": "uid_45_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_45_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-08-31",
          "category": "Account",
          "description": "Account statement - August 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_46_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_46_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-09-30",
          "description": "Statement - September 2017",
          "documents": [{
            "uid": "uid_47_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-10-31",
          "category": "Account",
          "description": "Account statement - October 2017",
          "documents": [{
            "uid": "uid_48_1",
            "contentType": "application/pdf"
          }, {
            "uid": "uid_48_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-11-30",
          "category": "Account",
          "description": "Account statement - November 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_49_1",
            "contentType": "application/pdf"
          }, {
            "url": "http://server.com/documentsdepo/uid_49_2",
            "contentType": "text/csv"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-12-31",
          "category": "Account",
          "description": "Account statement - December 2017",
          "documents": [{
            "uid": "uid_50_1",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-05-19",
          "category": "Mortgage",
          "description": "Mortgage statement - May 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_51",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-06-19",
          "category": "Mortgage",
          "description": "Mortgage statement - June 2017",
          "documents": [{
            "uid": "uid_52",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-06-20",
          "category": "Mortgage",
          "description": "Mortgage statement - July 2017",
          "documents": [{
            "url": "http://server.com/documentsdepo/uid_53",
            "contentType": "application/pdf"
          }]
        }, {
          "accountId": "6cdb2224-8926-4b4d-a99f-1c9dfbbb4699",
          "accountName": "The Walt Disney Company",
          "accountNumber": "UA85 3996 2200 0000 0260 0123 3566 1",
          "date": "2017-08-19",
          "category": "Mortgage",
          "description": "Mortgage statement - August 2017",
          "documents": [{
            "uid": "uid_54",
            "contentType": "application/pdf"
          }]
        }]
      },
      {
        status: 400,
        body: {
          "message": "Bad Request",
          "errors": [{
            "message": "Value Exceeded. Must be between {min} and {max}.",
            "key": "common.api.shoesize",
            "context": {
              "max": "50",
              "min": "1"
            }
          }]
        }
      },
      {
        status: 401,
        body: {
          "message": "Access to requested resource denied.",
          "errors": [{
            "message": "Resource access denied due to invalid credentials.",
            "key": "common.api.token",
            "context": {
              "accessToken": "expired"
            }
          }]
        }
      },
      {
        status: 403,
        body: {
          "message": "Access to requested resource denied.",
          "errors": [{
            "message": "Resource access denied due to an insufficient user quota of {quota}.",
            "key": "common.api.quota",
            "context": {
              "quota": "someQuota"
            }
          }]
        }
      },
      {
        status: 500,
        body: {
          "message": "Description of error"
        }
      },
    ]
  }
];
export const AccountStatementHttpServiceGetAccountStatementsMocksProvider = createMocks(examples, ARRANGEMENTS_DATA_HTTP_ANG_CONFIG);
